/** 既知の属名 typo → 正しい学名（表示・保存正規化・検索バリアント） */
const GENUS_DISPLAY_ALIASES: Record<string, string> = {
  francsiella: 'Francisella',
};

/** ダッシュボード／詳細／保存時の属名正規化 */
export function formatPathogenGenusDisplay(
  genus: string | null | undefined
): string {
  const raw = genus?.trim() ?? '';
  if (!raw) return '';
  return GENUS_DISPLAY_ALIASES[raw.toLowerCase()] ?? raw;
}

/** 検索・フィルタ用（正規名と typo の両方） */
export function pathogenGenusSearchVariants(
  genus: string | null | undefined
): string[] {
  const raw = genus?.trim() ?? '';
  if (!raw) return [];
  const canonical = formatPathogenGenusDisplay(raw);
  const out = new Set<string>([raw, canonical]);
  for (const [alias, fixed] of Object.entries(GENUS_DISPLAY_ALIASES)) {
    if (fixed.toLowerCase() !== canonical.toLowerCase()) continue;
    out.add(fixed);
    out.add(alias.charAt(0).toUpperCase() + alias.slice(1));
  }
  return [...out];
}

export type GenusCountBar = { genus: string; count: number };

/** 補正後に同名になった属を合算（チャートの二重棒を防ぐ） */
export function mergePathogenGenusBars(bars: GenusCountBar[]): GenusCountBar[] {
  const map = new Map<string, number>();
  for (const bar of bars) {
    const genus = formatPathogenGenusDisplay(bar.genus);
    if (!genus) continue;
    map.set(genus, (map.get(genus) ?? 0) + (bar.count ?? 0));
  }
  return [...map.entries()]
    .map(([genus, count]) => ({ genus, count }))
    .sort((a, b) => b.count - a.count || a.genus.localeCompare(b.genus));
}
